import { useTranslation } from "react-i18next";

import { WelcomeRateCards } from "@/components/FriendsWithBenefits/Sections/WelcomeRateCards";
import { Button } from "@/components/Interface/Button/Button.tsx";

export interface FriendsRatesCardProps {
  dataTestid?: string;
  /** Group discount in percent applied to the listed rates. */
  discount: number;
  onOrderFlatMobile: () => void;
}

/**
 * The Flat Mobile rate tiles with the group discount applied, shown
 * only while the customer has no eligible Flat Mobile of their own, together
 * with the entry point into the ordering flow.
 */
export const FriendsRatesCard = ({
  dataTestid,
  discount,
  onOrderFlatMobile,
}: FriendsRatesCardProps) => {
  const { t } = useTranslation("portal", {
    keyPrefix: "friendsWithBenefits.groupOverview",
  });

  return (
    <WelcomeRateCards
      dataTestid={dataTestid}
      tribeDiscount={discount}
      action={
        <Button
          dataTestid="fwb-order-flat-mobile"
          variant="primary"
          size="sm"
          onClick={onOrderFlatMobile}
        >
          {t("orderFM")}
        </Button>
      }
    />
  );
};
